import Cookies from "js-cookie";

const cookies = {
  setCookie: ({
    name,
    value,
    expire = 7,
  }: {
    name: string;
    value: string;
    expire?: number;
  }) => {
    Cookies.set(name, value, {expires: expire, path: "/"});
  },

  getCookie: ({name}: {name: string}) => {
    return Cookies.get(name);
  },

  deleteCookie: ({name}: {name: string}) => {
    Cookies.remove(name, {path: "/"});
  },
};

export default cookies;
